import type { UseQueryResult } from "@tanstack/react-query"
import { useQuery } from "@tanstack/react-query"

import { queryKeys } from "~/api/cache"

import { retrySolarRead } from "./solar-read-retry"
import type { SolarProposalSummaryDto } from "../dto/solar-proposal-summary.dto"
import { solarProposalService } from "../services/solar-proposal.service"

/**
 * Which Summary requirements the stored proposal meets: the server's one
 * definition of ready, which the confirm checks again. A pure read.
 */
export default function useSolarProposalSummary(
  proposalId: string | undefined,
): UseQueryResult<SolarProposalSummaryDto, unknown> {
  return useQuery({
    queryKey: queryKeys.solarProposal.summary(proposalId ?? ``),
    queryFn: () => solarProposalService.getSummary(proposalId ?? ``),
    enabled: Boolean(proposalId),
    retry: retrySolarRead,
  })
}
